"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getAnswerBoxStyles = void 0;

var _ColorHelper = require("../../../../helpers/ColorHelper");

var _ObjectHelper = require("../../../../helpers/ObjectHelper");

var getAnswerBoxStyles = function getAnswerBoxStyles(componentState) {
  var theme = null;

  if (componentState.quiz && componentState.currentTheme in componentState.quiz) {
    theme = componentState.quiz[componentState.currentTheme];
  }

  var defaultTheme = componentState.quiz ? componentState.quiz["default"] : null;
  var answerBoxStyle = {
    color: (0, _ObjectHelper.getObjectValueWithFallbacks)(theme, 'answerBoxText', defaultTheme, 'answerBoxText', (0, _ObjectHelper.getObjectValueWithFallbacks)(theme, 'quizText', defaultTheme, 'quizText', _ColorHelper.COLOR.BLACK))
  };
  var inputStyle = {
    backgroundColor: (0, _ObjectHelper.getObjectValueWithFallbacks)(theme, 'valueInputColor', defaultTheme, 'valueInputColor', _ColorHelper.COLOR.WHITE)
  };
  return {
    answerBoxStyle: answerBoxStyle,
    inputStyle: inputStyle
  };
};

exports.getAnswerBoxStyles = getAnswerBoxStyles;